import React, { useState, useEffect } from "react";
import { string } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import DfpAd from "../../dfp-ad";

const InterstitialAdFormatTwo = ({ pageType, collectionName }) => {
  const [isInterstitialAd, setInterstitialAd] = useState(true);

  useEffect(() => {
    setInterstitialAd(true);
    if (
      window &&
      (window.location.href.includes("auth.prothomalo") || window.location.href.includes("auth.prothom-alo"))
    ) {
      setInterstitialAd(false);
    }
  });

  useEffect(() => {
    setInterstitialAd(false);
    if (
      window &&
      (window.location.href.includes("auth.prothomalo") || window.location.href.includes("auth.prothom-alo"))
    ) {
      setInterstitialAd(false);
    }
  }, [pageType]);

  useEffect(() => {
    if (collectionName) {
      setInterstitialAd(false);
    }
  }, [collectionName]);

  const getAdType = () => {
    return "Web_Interstitial_AdX";
  };

  if (!isInterstitialAd) {
    return null;
  }

  return isInterstitialAd ? <DfpAd adtype={getAdType()} slotId="interstial-ad-format-two" /> : null;
};

const mapStateToProps = (state) => ({
  pageType: get(state, ["qt", "pageType"], ""),
  collectionName: get(state, ["qt", "data", "collection", "name"], ""),
});

InterstitialAdFormatTwo.propTypes = {
  pageType: string,
  collectionName: string,
};

export default connect(mapStateToProps, null)(InterstitialAdFormatTwo);
